export enum FeatureStates {
    Default = 1,
    Highlighted,
    Hovered
}